import classes from './input.module.css';

const TextArea = ({
	customClass, 
	isTouched, 
	isValid, 
	errorMessage, 
	attributes, 
	value,
	valueChangeHandler, 
	inputBlurHandler
}) => {

	const styles = [customClass];
	
	if ( isTouched && isValid && errorMessage ) {
		styles.push(classes.invalid);
	}

	const error = errorMessage ? <div className={`errorTxt`} >{ errorMessage }</div> : null

	return (
		<>
			<textarea 
				className={styles.join(' ')} 
            rows={2}
				{...attributes}
				value={value} 
				onChange={ valueChangeHandler } 
				onBlur={ inputBlurHandler } />
			{ error }
		</>
	);
}

export default TextArea;